// extracted by mini-css-extract-plugin
export var byline = "ProjectCard-module--byline--DagfH";
export var deactivated = "ProjectCard-module--deactivated--heaz2";
export var description = "ProjectCard-module--description--6DMdd";
export var imageWrapper = "ProjectCard-module--image-wrapper--Z8y+X";
export var projectCard = "ProjectCard-module--project-card--g8-A7";
export var projectLink = "ProjectCard-module--project-link--f36ZY";
export var textWrapper = "ProjectCard-module--text-wrapper--Z7ncF";
export var title = "ProjectCard-module--title--uY6jK";